import styled, { css } from "styled-components";

import type { ColorName } from "styles/config/colors";
import themeColors from "styles/config/colors";
import themeSpacing from "styles/config/spacing";
import text from "styles/config/text";

export const Label = styled.label<{ $fullWidth?: boolean }>`
  position: relative;
  display: flex;
  flex-direction: column;

  ${({ $fullWidth }) =>
    $fullWidth &&
    css`
      width: 100%;
    `}
`;

export const RightLabel = styled.span``;

export const LabelWrapper = styled.div<{
  $inverse?: boolean;
  $labelColor?: ColorName;
}>`
  display: flex;
  align-items: center;
  justify-content: space-between;

  margin-bottom: ${themeSpacing.xs1};

  font-size: ${text.size.body.small};
  color: ${({ $labelColor }) =>
    $labelColor ? themeColors[$labelColor] : themeColors.textSecondary};

  ${({ $inverse }) =>
    $inverse &&
    css`
      color: ${themeColors.textPrimaryInverse};
    `}
`;

export const InputWrapper = styled.div<{ $fullWidth?: boolean }>`
  display: flex;
  align-items: center;

  ${({ $fullWidth }) =>
    $fullWidth &&
    css`
      width: 100%;
    `}
`;

export const ErrorWrapper = styled.div`
  margin-top: ${themeSpacing.xs2};
`;
